import { loadStripe } from '@stripe/stripe-js';

// Initialize Stripe with publishable key
const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 
  'pk_live_51RYsydIkwUVtcv9MzmpM9ZOQI99ZnnAG1VGwTepuJSqIMa4aP4qXdHAS5t9gPWeDdwBKVbW8jnSnR5gfjX0AJvdy00yV4yI370'
);

// Subscription plans configuration
export const SUBSCRIPTION_PLANS = {
  professional: {
    name: 'Professional',
    price: '€199.99/year (excl VAT)',
    displayPrice: '€199.99/year (excl VAT)',
    amountCents: 19999,
    priceId: 'price_1TrMOMIkwUVtcv9M3cZ3qhGX',
    period: 'yearly',
    canTakeTests: true,
    canDownloadCertificates: true,
    features: [
      'Read unlimited articles across all professions',
      'Earn official CPD points worldwide',
      'Download accredited certificates', 
      'Take short tests (5 AI-generated questions)',
      'Request favorite articles for CPD points',
      'Track progress and certification history',
      'Email support'
    ]
  },
  professionalMonthly: {
    name: 'Professional Monthly',
    price: '€19.99/month (excl VAT)',
    displayPrice: '€19.99/month (excl VAT)',
    amountCents: 1999,
    priceId: 'price_1TrMaeIkwUVtcv9MDRqJUJ0N',
    period: 'monthly',
    canTakeTests: true,
    canDownloadCertificates: true,
    features: [
      'Read unlimited articles across all professions',
      'Earn official CPD points (2 points/month allowance, rolls over)',
      'Download accredited certificates',
      'Take short tests (5 AI-generated questions)',
      'Track progress and certification history',
      'Email support'
    ]
  }
};

// API endpoints
export const STRIPE_API = {
  CREATE_CHECKOUT: '/api/stripe/create-checkout-session',
  CREATE_PORTAL: '/api/stripe/create-portal-session',
  VERIFY_SUBSCRIPTION: '/api/stripe/verify-subscription'
};

export default stripePromise; 